
// Enable scrollTo and other behavior for older browsers
import smoothscroll from 'smoothscroll-polyfill';

// Start the smoothscroll polyfill!
smoothscroll.polyfill();
